import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { observer } from 'mobx-react';
import { Button } from '@mui/material';
import { styled } from '@mui/system';
import { isEmpty } from 'lodash';

import './scss/index.scss';
import Color from '@tool/color';
import IndustryEffect from './industry-effect/index';
import EffectTrend from './effect-trend/index';
import Title from '../component/title';
import Indicators from '../component/indicators';
import moSkin from '@store/skin';
import moUser from '@store/user';
import moStore, { toggleValue } from '@store/index';
import moEffect from '../store/index';
import moSupport, { supportInit } from './store/index';
import moIndustryEffect, {
  industryEffectInit,
} from './industry-effect/store/index';
import moEffectTrend, {
  effectTrendInit,
} from './effect-trend/store/index';

interface IProps {}
interface IState {}

const SupportEffect = (props: IProps, state: IState) => {
  const navi = useNavigate();
  const [supportOpen, setSupportOpen] = useState(true);
  const supportList = [
    '支持效能：在所选行业、年度下，薪智调研的所有公司的各类支持效能的平均值。',
  ];

  useEffect(() => {
    const show = localStorage.getItem('showIndicator');
    if (show === 'false') setSupportOpen(false);
    else setSupportOpen(true);

    return () => {};
  }, []);

  const onOpenSupport = () => {
    setSupportOpen(true);
  };

  const onCloseSuport = () => {
    setSupportOpen(false);
  };

  return (
    <section className="support-effect_10">
      <Title title="支持效能" subtitle="支持效能" onIndi={onOpenSupport} />
      {supportOpen && <Indicators onClose={onCloseSuport} list={supportList} />}
      <IndustryEffect />
      <EffectTrend />
    </section>
  );
};

export default observer(SupportEffect);
